module.exports = __webpack_public_path__ + "media/images/site/whats-b20ed105cca25f6c9902753dae93abcb.svg";